// Minimal accents — legacy component names preserved so existing pages keep working.
// Previously these were hand-drawn SVGs; now they're clean editorial marks.
import React from "react";
import { ArrowRight } from "lucide-react";

export const Marked = ({ children, className = "" }) => (
  <span className={`relative inline-block ${className}`}>
    <span className="relative z-10">{children}</span>
    <span
      className="absolute left-0 right-0 -bottom-0.5 h-[3px] bg-terracotta/85 rounded-full pointer-events-none"
      aria-hidden="true"
    />
  </span>
);

// Old decorative variants collapsed to Marked
export const DoubleUnderline = Marked;
export const Underline = () => null;
export const Circle = () => null;
export const Scribble = () => null;
export const Asterisk = () => null;
export const Star = () => null;

export const ArrowDraw = ({ className = "" }) => (
  <ArrowRight className={className} strokeWidth={2} />
);

// Small clean chip (formerly a marker-font tilted tag)
export const HandTag = ({ children }) => (
  <span className="inline-flex items-center px-2.5 py-1 text-[10px] tracking-[0.24em] uppercase font-semibold text-terracotta border border-terracotta/40 rounded-full">
    {children}
  </span>
);

const HandDrawn = { Marked, Underline, DoubleUnderline, Circle, ArrowDraw, Asterisk, Scribble, Star, HandTag };
export default HandDrawn;
